import { useGetSettings } from '@ipfabric/api-client/client/model/settings/settings';
import { triggerAnalyticsEvent } from 'app/analytics/posthogEvents';
import { useNotifications } from 'utils/hooks/useNotifications';
import { renderQuery } from 'utils/react-query/renderQuery';
import { useApi } from 'utils/request/useApi';
import { DiscoverySettings } from '../composition/DiscoverySettings/DiscoverySettings';
import { pickDiscoverySettingsFromGlobalSettings } from '../utils/pickDiscoverySettingsFromGlobalSettings';

export const GlobalDiscoverySettingsPage = () => {
  const globalSettingsQuery = useGetSettings();
  const api = useApi();
  const notifications = useNotifications();

  return renderQuery({
    query: globalSettingsQuery,
    renderStaleDataOnMount: false,
    success: (data) => (
      <DiscoverySettings
        initialModel={pickDiscoverySettingsFromGlobalSettings(data)}
        onSubmit={async (discoverySettingsObject) => {
          triggerAnalyticsEvent({
            eventName: 'form_submit',
            data: {
              form_name: 'global_discovery_settings',
              trigged_by: 'mouse_click',
            },
          });
          const response = await api.request({
            url: '/settings',
            method: 'PATCH',
            data: discoverySettingsObject,
          });
          notifications.showNotification({
            type: 'success',
            message: 'Settings saved',
          });
          return response;
        }}
        snapshotId={null}
        showUpdateFromGlobalSettingsButton={false}
      />
    ),
  });
};
